import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/index.css';
import reportWebVitals from './reportWebVitals';
import {  createBrowserRouter,  RouterProvider } from "react-router-dom";
import contentRouter from "./Routes/ContentRoutes";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <RouterProvider router={createBrowserRouter(contentRouter, {basename: "/Wheelsky"})} />  
);

reportWebVitals();
